import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NzModalService} from "ng-zorro-antd/modal";
import {Subscription} from "rxjs";
import {SearchBrandComponent} from "../search-brand/search-brand.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Brand} from "../../../../models/Brand";
import {CreateBrandComponent} from "../../../../pages/admin/brands/create-brand/create-brand.component";

@Component({
  selector: 'app-brand-selector',
  templateUrl: './brand-selector.component.html',
  styleUrls: ['./brand-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BrandSelectorComponent),
      multi: true
    }
  ]
})
export class BrandSelectorComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() type: 'new' | 'update' = 'update';
  view: 'update' | 'selected' = 'selected';
  value: Brand | null;
  @Output() customerSelected: EventEmitter<any> = new EventEmitter();
  customerSelectedSubscription: Subscription;

  onTouch: any = () => {}
  onChange: any = () => {}

  constructor(public modalService: NzModalService) {

  }

  ngOnInit(): void {
    this.customerSelectedSubscription = this.customerSelected.subscribe((data)=>{
      if(data){
        this.value = data;
        this.view = 'selected';
        this.onChange(data);
      }
    });
  }

  ngOnDestroy() {
    this.customerSelectedSubscription.unsubscribe();
  }

  selectDialog(){

    this.modalService.create({
      nzTitle: 'Select Existing Brand',
      nzContent: SearchBrandComponent,
      nzClassName: 'newCustomerModal',
      nzWidth: '700px',
      nzMaskClosable: false,
      nzAfterClose: this.customerSelected
    });

  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
    console.log(obj);
    if(obj){
      this.view = 'selected';
    }
  }

  convertNameToImage(name: string): string{
    name = name.replace(' ', '+');
    return 'https://eu.ui-avatars.com/api/?background=random&name=' + name;
  }

  changeBrand(){

    if(this.type === 'new'){
      console.log(this.type);
      this.value = null;
      this.onChange(null);
      console.log(this.value);
    }
    this.view = 'update';

  }

}
